var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 6.25H9C8.58579 6.25 8.25 6.58579 8.25 7V8.55555V8.55555V10.1112C8.25 10.2925 8.31571 10.4677 8.43497 10.6044C10.2592 12.6943 10.8715 14.9935 11.1704 17.964C11.209 18.3472 11.5315 18.6389 11.9167 18.6389H12L12 21C12 21.2563 12.1309 21.4949 12.3471 21.6326C12.5633 21.7703 12.8349 21.788 13.0672 21.6796L15.5672 20.5129C15.8312 20.3897 16 20.1247 16 19.8333V18.6389H16.0833C16.4685 18.6389 16.791 18.3472 16.8296 17.964C17.1285 14.9935 17.7408 12.6943 19.565 10.6044C19.6843 10.4677 19.75 10.2925 19.75 10.1112V8.55676L19.75 8.55555V7C19.75 6.80109 19.671 6.61032 19.5303 6.46967C19.3897 6.32902 19.1989 6.25 19 6.25ZM15.2594 17.1389H15.4118C15.7437 14.4111 16.4244 12.0268 18.25 9.83487V9.30561L9.75 9.30561L9.75 9.83487C11.5756 12.0268 12.2563 14.4111 12.5882 17.1389H12.7406C12.7437 17.1389 12.7469 17.1389 12.75 17.1389L15.25 17.1389C15.2531 17.1389 15.2562 17.1389 15.2594 17.1389Z",
    fill: "#050022"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.18e67371ac5838d20eb2671a79d20269.svg";
export { ForwardRef as ReactComponent };